<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row align="center" justify="start" no-gutters >
              <v-col :cols="12" :md="4" :sm="4" class="pa-2" v-if="organisationType === 'GOVERMENT' ||
                  organisationType === 'COOP BANK'">
                <div class="autocomplete-container" >
                  <v-text-field
                    label="Search"
                    v-model="search"
                    @input="onInput"
                    :loading="loading"
                    clearable
                    class="w-100"
                  ></v-text-field>

                  <v-list
                    v-if="filteredItems.length"
                    class="autocomplete-list"
                    style="position: absolute; z-index: 1; background: grey; max-height: 200px; overflow-y: auto;"
                  >
                    <v-list-item
                      v-for="(item, index) in filteredItems"
                      :key="index"
                      @click="selectItem(item)"
                    >
<!--                      <v-list-item-content>
                        <v-list-item-title>{{ item }}</v-list-item-title>
                      </v-list-item-content>-->
                    </v-list-item>
                  </v-list>
                </div>
              </v-col>

              <v-col :cols="12" :md="4" :sm="4" class="pa-2">
                <v-select
                  label="Seasons"
                  item-text="name"
                  class="w-100"
                  item-value="value"
                  v-model="sale_season"
                  :items="seasons"
                  variant="solo-filled"
                  @change="onChangeSelect"
                  solo
                  hide-details
                  return-object
                  dense
                ></v-select>
              </v-col>

              <v-col :cols="12" :md="4" :sm="4" class="pa-2">
                <v-btn @click="getStockGrade" class="w-100 secondary">Search</v-btn>
              </v-col>
            </v-row>          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" :items="eslips" :search="search"
                          :hide-default-footer="true" class="elevation-1">
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="9">
                <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
                              prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import _ from 'lodash'
import * as XLSX from 'xlsx';
import { convertRulesToOptions } from 'devextreme/core/options/utils'

export default {
	name: 'StockStatusGrade2',
	data: function () {
		return {
			headers: [
				{
					text: 'Grower Code',
					value: 'growerCode'
				},
        {
          text: 'Grade',
          value: 'grade'
        },
        {
          text: 'Season',
          value: 'season'
        },
				{
					text: 'Weight',
					value: 'totalWeight'
				},
				/* {
					text: 'Average Price/KG',
					value: 'amount'
				}, */
				{
					text: 'Total Price',
					value: 'totalPrice'
				}
			],
			items: ['Apple', 'Bananananana', 'Orange', 'Grape', 'Peach', 'Pear'],
			filteredItems: [],
			sale_season: '',
			startdate: '',
			eslips: [],
			growerCodes: [],
			seasons: [],
			startDate: '',
			endDate: '',
			message: '',
			loading: false,
            currentYear: new Date(),
			totalEslips: 0,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			pagination: {
				sortBy: 'id',
				descending: true
			},
			dialog: false,
			eslip: {},
			search: '',
			page: 1,
			totalPages: 0,
			pageSize: 7,
			pageSizes: [5, 10],
      theUser: [],
      organisationType: '',
      organisationCode: ''
		}
	},
	watch: {
		/* search: function (newSearch) {
			// Reset page number when search changes
			this.page = 1
			this.debouncedGetEslips()
		} */
		// search: function (oldValue, newValue) {
		//   this.debouncedGetAnswer()
		// }
	},
	mounted () {
    this.getLoggedInUser()
		this.getStockGrade()
		//this.getGrowerStatement()
		this.getGrowerCodes()
		this.getSeasons()
	},
	methods: {
    getLoggedInUser () {
      this.theUser = JSON.parse(localStorage.getItem('user'))
      console.log('user ===>> ', this.theUser)
      // this.curUserN = this.curUser.firstName
      this.organisationType = this.theUser.organisation.organisationType.name
      this.organisationCode = this.theUser.organisation.organisationCode
    },
		exportExcel() {
      // Define worksheet and workbook
      const ws = XLSX.utils.json_to_sheet(this.eslips,
	//   {
    //     header: Object.keys(this.headers)
    //   }
	);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // Export workbook to file
      XLSX.writeFile(wb, this.accountNumber+'_'+this.accountName+'_Statement.xlsx');
    },
		onInput () {
			this.loading = true
			setTimeout(() => {
				/* if (this.search) {
					this.filteredItems = this.growerCodes.filter(item =>
						item.toLowerCase().includes(this.search.toLowerCase())
						// item.toLowerCase().includes(this.search.toLowerCase())
					)
				} else {
					this.filteredItems = []
				}
				this.loading = false */
        this.loading = false
      }, 300) // Simulate a delay, like a network request
		},
		selectItem (item) {
			this.search = item
			this.filteredItems = []
		},
		getSeasons () {
			this.seasons.push('2023/2024')
			this.seasons.push('2024/2025')
			const month = this.currentYear.getMonth()
			const year = this.currentYear.getFullYear()
			if (month < 10) {
				this.seasons.push(year + '/' + (year + 1))
				this.seasons.push(year + 1 + '/' + (year + 2))
			} else {
				this.seasons.push(year + 1 + '/' + (year + 2))
				this.seasons.push(year + 3 + '/' + (year + 4))
			}
		},
		onChangeSelect (value) {
			const year = this.currentYear.getFullYear()
			const selectedYear = value.split('/')[0]
			console.log('Year:', year)
			console.log('Selected option:', value, selectedYear)
			if (selectedYear === year.toString()) {
				const month = ('0' + (this.currentYear.getMonth() + 1)).slice(-2)
				const day = ('0' + this.currentYear.getDate()).slice(-2)
				this.sale_start_date_min = this.currentYear.getFullYear() + '-' + month + '-' + day
				this.sale_start_date_max = this.currentYear.getFullYear() + '-10-01'
			} else {
				console.log('two')
				this.sale_start_date_min = this.currentYear.getFullYear() + '-10-01'
				this.sale_start_date_max = (this.currentYear.getFullYear() + 1) + '-09-30'
				// this.sale_end_date_min = (this.currentYear.getFullYear() + 1) + '-09-30'
			}
			// You can access the selected value directly using the value parameter
		},
		goToStock (item) {
			console.log('item --->> ', item.id)
			this.$router.push('/grower/stock/' + item.id)
		},
		checkDate (event, dte) {},
		getRequestParams (name, page, pageSize) {
			const params = {}
			if (page) {
				params.page = page - 1
			}
			if (pageSize) {
				params.size = pageSize
			}
			if (name) {
				params.eslipNumber = name
			}
			return params
		},
    getRequestParams2 (name, season, page, pageSize) {
      const params = {}
      if (page) {
        params.page = page - 1
      }
      if (pageSize) {
        params.size = pageSize
      }
      if (name) {
        params.growerCode = name
      }
      if (season) {
        params.season = season
      }
      return params
    },
		getStockGrade () {
			// const params = this.getRequestParams('E240816J9N', this.page, this.pageSize)
			// const params = this.getRequestParams(this.search, this.page, this.pageSize)
     // const params = this.getRequestParams2(this.search, this.sale_season, this.page, this.pageSize)
			// const url = config.serverURI + '/grower-stock-grades'
      let params = this.getRequestParams2(this.search, this.sale_season, this.page, this.pageSize)
      if (this.organisationType !== 'GOVERMENT' && this.organisationType !== 'COOP BANK') {
        params = this.getRequestParams2(this.organisationCode, this.sale_season, this.page, this.pageSize)
      }
			const url = config.serverURI + '/growerstatus/stockgrade'
			axios.get(url, { params })
				.then(response => {
					console.log('Stock Grade data 101', response.data.content)
					// const {
					// 	items,
					// 	totalPages
					// } = response.data
					this.eslips = response.data.content
					this.totalPages = totalPages
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.eslips
		},
		getGrowerCodes () {
			const url = config.serverURI + '/organization/get-marketers'
			axios.get(url)
				.then(response => {
					console.log('FCS - ', response.data)
					//this.growerCodes = response.data
          response.data.forEach(x => {
            //console.log('->> ', x['organisationCode']);
            this.growerCodes.push(x['organisationCode'])
          })
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.growerCodes
		},
		debouncedGetEslips: _.debounce(function () {
			this.getStockGrade()
		}, 500),
		triggerDownload (item) {
			const url = config.serverURI + '/eslip/download/' + item.id
			axios({
				url: url,
				method: 'POST',
				responseType: 'blob'
			})
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyer.organisationName + '_' + item.created + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		displayEslipDetails (item) {
			this.dialog = true
			this.eslip = item
		},
		hideDialog () {
			this.dialog = false
		},
		handlePageChange (value) {
			this.page = value
			this.getStockGrade()
		},
		handlePageSizeChange (size) {
			this.pageSize = size
			this.page = 1
			this.getStockGrade()
		}
	}
	// created: function () {
	//   this.debouncedGetAnswer = _.debounce(this.getStockGrade, 1000)
	//   this.debouncedGetAnswer = _.debounce(this.getGrowerStatement, 1000)
	// },

}

</script>
<style>
.search-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
}

.search-box {
  flex: 1;
  margin-right: 1em;
}

.date-filters {
  display: flex;
  gap: 1em;
}
</style>
